import React,{useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {motion} from 'framer-motion';
import {useAuth} from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMail,FiLock,FiLogIn,FiAlertCircle,FiHome,FiArrowLeft}=FiIcons;

const LoginForm=()=> {
  const navigate=useNavigate();
  const {login,error: authError}=useAuth();
  const [formData,setFormData]=useState({
    email: '',
    password: ''
  });
  const [errors,setErrors]=useState({});
  const [isSubmitting,setIsSubmitting]=useState(false);
  const [loginMessage,setLoginMessage]=useState('');

  const handleChange=(e)=> {
    const {name,value}=e.target;
    setFormData(prev=> ({
      ...prev,
      [name]: value
    }));

    // Clear errors when user types
    if (errors[name]) {
      setErrors(prev=> ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm=()=> {
    const newErrors={};

    if (!formData.email.trim()) {
      newErrors.email='E-Mail ist erforderlich';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email='Ungültige E-Mail-Adresse';
    }

    if (!formData.password) {
      newErrors.password='Passwort ist erforderlich';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length===0;
  };

  const handleSubmit=async (e)=> {
    e.preventDefault();
    setLoginMessage('');

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      // Nur die spezifische E-Mail-Adresse zulassen
      if (formData.email==='news@hopp.sg' && formData.password==='admin8970') {
        await login(formData.email,formData.password);
        navigate('/admin');
      } else {
        setLoginMessage('Ungültige Anmeldeinformationen. Zugriff verweigert.');
      }
    } catch (err) {
      console.error('Auth error:',err);
      setLoginMessage('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // 🔥 NEUE FUNKTION: Zur Homepage navigieren
  const handleGoToHomepage=()=> {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-amber-50 p-4">
      <motion.div
        initial={{opacity: 0,y: 20}}
        animate={{opacity: 1,y: 0}}
        className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full"
      >
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Admin Login
        </h2>

        {(authError || loginMessage) && (
          <div className="mb-6 p-4 bg-red-50 rounded-xl border border-red-200 flex items-center text-red-700">
            <SafeIcon icon={FiAlertCircle} className="mr-2 flex-shrink-0" />
            <span>{authError || loginMessage}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              E-Mail
            </label>
            <div className="relative">
              <SafeIcon 
                icon={FiMail} 
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" 
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`w-full pl-10 pr-4 py-3 border rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors ${
                  errors.email ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="news@hopp.sg"
              />
            </div>
            {errors.email && (
              <p className="mt-1 text-sm text-red-600">{errors.email}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Passwort
            </label>
            <div className="relative">
              <SafeIcon 
                icon={FiLock} 
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" 
              />
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={`w-full pl-10 pr-4 py-3 border rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors ${
                  errors.password ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="••••••••"
              />
            </div>
            {errors.password && (
              <p className="mt-1 text-sm text-red-600">{errors.password}</p>
            )}
          </div>

          <motion.button
            type="submit"
            disabled={isSubmitting}
            whileHover={{scale: 1.02}}
            whileTap={{scale: 0.98}}
            className={`w-full flex items-center justify-center space-x-2 bg-primary-500 text-white py-3 rounded-xl font-semibold hover:bg-primary-600 transition-colors duration-300 ${
              isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
            }`}
          >
            <span>Anmelden</span>
            <SafeIcon icon={FiLogIn} />
          </motion.button>
        </form>

        {/* 🔥 NEUER LINK ZUR HOMEPAGE */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <motion.button
            onClick={handleGoToHomepage}
            whileHover={{scale: 1.02}}
            whileTap={{scale: 0.98}}
            className="w-full flex items-center justify-center space-x-2 bg-gray-100 text-gray-700 py-3 rounded-xl font-medium hover:bg-gray-200 transition-colors duration-300"
          >
            <SafeIcon icon={FiHome} />
            <span>Zurück zur Homepage</span>
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginForm;